import { Utils } from "./utils/utils";

export enum AsciiColor {
	reset = "\x1b[0m",
	red = "\x1b[31m",
	green = "\x1b[32m",
	yellow = "\x1b[33m",
	blue = "\x1b[34m",
	magenta = "\x1b[35m",
	cyan = "\x1b[36m",
	white = "\x1b[37m",
}

enum LogColors {
	Reset = AsciiColor.reset,
	Error = AsciiColor.red,
	Warning = AsciiColor.yellow,
	Info = AsciiColor.cyan,
	Debug = AsciiColor.green,
}

class UseColor {
	static get Reset() {
		return false ? AsciiColor.reset : "";
	}
	static get Error() {
		return false ? AsciiColor.red : "";
	}
	static get Warning() {
		return false ? AsciiColor.yellow : "";
	}
	static get Info() {
		return false ? AsciiColor.cyan : "";
	}
	static get Debug() {
		return false ? AsciiColor.green : "";
	}
}

export function logJSError(error: Error) {
	console.error(UseColor.Error, _getLogTime(), error, UseColor.Reset);
}
function _getLogTime() {
	return new Date().toLocaleTimeString("en-US", { hour12: false });
}
export function logCritical(...messages: any[]) {
	const stack3to6 = new Error().stack?.split("\n").slice(3, 6).join("\n");
	// const caller = new Error().stack?.split('\n')[3].trim();
	console.error(UseColor.Error, "!!!!!!!!", _getLogTime(), ...messages, "!!!!!!!!", UseColor.Reset, stack3to6);
}
export function logError(...messages: any[]) {
	const stack3to6 = new Error().stack?.split("\n").slice(3, 6).join("\n");
	// const caller = new Error().stack?.split('\n')[3].trim();
	console.error(UseColor.Error, _getLogTime(), ...messages, UseColor.Reset, stack3to6 ?? "");
}
export function logErrorNoStack(...messages: any[]) {
	console.error(UseColor.Error, _getLogTime(), ...messages, UseColor.Reset);
}
export function logWarningNoStack(...messages: any[]) {
	console.warn(UseColor.Warning, _getLogTime(), ...messages, UseColor.Reset);
}

export function logWarning(...messages: any[]) {
	const stack3to6 = new Error().stack?.split("\n").slice(3, 6).join("\n");
	// const caller = new Error().stack?.split('\n')[3].trim();
	console.warn(UseColor.Warning, _getLogTime(), ...messages, UseColor.Reset, stack3to6);
}

export function logInfo(...messages: any[]) {
	console.log(UseColor.Info, _getLogTime(), ...messages, UseColor.Reset);
}

export function logDebug(...messages: any[]) {
	console.log(UseColor.Debug, _getLogTime(), ...messages.map((o) => o && Utils.clone(o)), UseColor.Reset);
}
